import { CDN_HOST, IS_DISCORD_ACTIVITY } from '@/globals';

export function pathToURL(path: string): string {
    // if (path?.startsWith('/')) return path; // To allow local paths to work in storybook
    return path && CDN_HOST + path;
}

// Convert urls to discord friendly urls
// These urls need to use the settings in the discord application url mapping section.
// Ref: https://discord.com/developers/docs/activities/development-guides#url-mapping
export function parsePayloadURLS<T>(json: T): T {
    if (!IS_DISCORD_ACTIVITY) return json;

    // Ideally we don't do this here, and also not hardcode twd stuff.
    const jsonString = JSON.stringify(json)
        .replaceAll('https://content.ariseworlds.com/ariseware/', '/.proxy/arisecontent/ariseware/')
        .replaceAll('https://twd.dev.arise-engine.com/', '/.proxy/twddev/')
        .replaceAll('https://cdn.ariseworlds.com/', '/.proxy/twdprod/')

    return JSON.parse(jsonString);
}
